import './Sidebar.css';
import FilterOptions from './FilterOptions/FilterOptions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Container } from 'reactstrap';
import { actions } from '../../context';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import PracticesList from './PracticesList/PracticesList';
import Loader from '../Overview/PracticeOverview/Loader';

const Sidebar: React.FC = () => {
  const dispatch = useDispatch();

  //handles re-sizing of practice list element
  // TODO: use css with classes for this instead of whatever this is. This creates the scroll bar for the practice list.
  const [listHeight, setListHeight] = useState<string>('');
  const listHeightTimeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);
  const toggleSearch = useCallback(() => {
    listHeightTimeoutId.current = setTimeout(() => {
      const sidebar = document.getElementById('Sidebar');
      const options = document.getElementById('filterOptions');
      if (window.innerWidth < 768) setListHeight('100%');
      else setListHeight(`${(sidebar?.clientHeight ?? 0) - (options?.clientHeight ?? 0) - 85}px`);
    }, 50);
  }, []);
  window.onresize = toggleSearch;

  useEffect(() => {
    const sidebar = document.getElementById('Sidebar');
    const filterOptions = document.getElementById('filterOptions');
    setListHeight(`${(sidebar?.clientHeight ?? 0) - (filterOptions?.clientHeight ?? 0) - 85}px`);
  }, []);

  const {
    isMutePracticeModalOpen,
    isPracticeScheduleModalOpen,
    isPracticeWorkflowModalOpen,
    daylightCodeModalVisible,
  } = useSelector(
    (state: any) => ({
      isMutePracticeModalOpen: state.toggle.isMutePracticeModalOpen, // bool used to show the mute practice modal
      isPracticeScheduleModalOpen: state.toggle.isPracticeScheduleModalOpen, // bool to show the Practice Sync Schedule modal is open on the practice page
      isPracticeWorkflowModalOpen: state.toggle.isPracticeWorkflowModalOpen,
      daylightCodeModalVisible: state.daylight.daylightCodeModalVisible,
    }),
    shallowEqual,
  );

  const isLoading = useSelector((state: any) => state.isAllPracticesLoading);

  // DATA SYNC
  // TODO: Get this out of here
  // TODO: There is a Overiew and Daylight modal sync as well
  useEffect(() => {
    //put any conditions which should kill the interval loop in this if statement
    if (
      isMutePracticeModalOpen ||
      isPracticeScheduleModalOpen ||
      isPracticeWorkflowModalOpen ||
      daylightCodeModalVisible
    ) {
      return;
    }
    //otherwise continue with interval function
    const intervalFunction = setInterval(
      () => dispatch(actions.toggle.triggerRefresh()),
      1000 * 30,
    );
    return () => {
      clearInterval(intervalFunction);
      if (listHeightTimeoutId.current) {
        clearTimeout(listHeightTimeoutId.current);
      }
    };
  }, [
    dispatch,
    isMutePracticeModalOpen,
    isPracticeScheduleModalOpen,
    isPracticeWorkflowModalOpen,
    daylightCodeModalVisible,
  ]);

  let listContent = <PracticesList />;

  if (isLoading === true) {
    listContent = <Loader />;
  }

  return (
    <Container
      id="Sidebar"
      style={{ top: '4rem' }}
      className="px-1 m-0 sc-rounded sc-glass sticky-top">
      <div className="text-center pt-3">
        <h3 className="text-light">Practices</h3>
      </div>

      <FilterOptions onSearchOpen={toggleSearch} />

      <div id="sidescroller" style={{ width: '100%', height: listHeight }}>
        {listContent}
      </div>
    </Container>
  );
};

export default React.memo(Sidebar);
